/*Created by AP*/

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {IAdjacentBetLineWinData} from "../../utils/SymbolUtil";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsReelController} from "../reel/DirtyWildsReelController";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildsStateReelSymbol} from "../symbols/DirtyWildsStateReelSymbol";
import {DirtyWildGameMode} from "./DirtyWildsRespinZeroBetController";

export class DirtyWildsRFSyncEvent {
    public static readonly INIT_SPEED_ACHIEVED:string = "dirtyWildsRFSyncEvent_initSpeedAchieved";
    public static readonly ANIMATE_SECOND_SET:string = "dirtyWildsRFSyncEvent_animateSecondSet";
    public static readonly ADD_DIRTY_SYNC_DELAY:string = "dirtyWildsRFSyncEvent_addDirtySyncDelay";
    public static readonly SET_EVENT_VARIABLE:string = "dirtyWildsRFSyncEvent_setEventVariable";
}

export class DirtyWildsRFSyncController extends BeforeSpinStopPresentationController {
    private _isRandomSyncFeatureTriggered:boolean;
    private _beforeStopSpinsRemaining:number;
    private _initialStopDelay:number = 0;
    private _reelStopped:number[] = [];
    private _possibleWinSymbols:string[];
    private _betWins:IAdjacentBetLineWinData[];

    constructor(index:number, name:string) {
        super(index, name);
    }

    protected getSpinStopDelay(data:ParsedGameData):number {
        return 0;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, DirtyWildsRFSyncEvent.INIT_SPEED_ACHIEVED, (event:GameEvent) => this.slowDownReels(event.params[0], event.params[1], event.params[2], event.params[3], event.params[4]));
        EventHandler.addEventListener(this, DirtyWildsRFSyncEvent.ANIMATE_SECOND_SET, (event:GameEvent) => this.onReelStopStarted(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.resetSyncFeature());
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_COMPLETE, (event:GameEvent) => this.onReelStop(event.params[0]));
    }

    private onReelStopStarted(data:number):void {
        if(this._isRandomSyncFeatureTriggered) {
            const slowReels:number[] = [1, 2, 3];
            if(data === 1) {
                for(let reel of slowReels) {
                    //this.slowDownReels(reel, 0.1, 3);
                }
            }
        }
    }

    private onReelStop(data:number):void {
        this._reelStopped.push(data);
        if(this._isRandomSyncFeatureTriggered) {
            switch(data) {
                case 1:
                    DirtyWildGameModuleConfig.environment.stopMysteryPresentation();
                    this.slowDownReels(0, 0.15, 10, true);
                    break;
                case 0:
                    DirtyWildGameModuleConfig.environment.stopMysteryPresentation();
                    this.slowDownReels(4, 0.15, 10, true, true);
                    break;
                case 4:
                    SlotGame.sound.stopEffect(DirtyWildsSoundConfig.ANTICIPATION_SYNC);
                    DirtyWildGameModuleConfig.environment.stopMysteryPresentation();
                    break;
            }

            if(this._reelStopped.length > 4) {
                this._reelStopped = [];
                if(!(this._betWins && this._betWins.length > 0)) {
                    const inActiveReels:number[] = [0, 4];
                    for(let i:number = 0; i < inActiveReels.length; i++) {
                        for(let j:number = 0; j < 3; j++) {
                            const symbol:DirtyWildsStateReelSymbol = <DirtyWildsStateReelSymbol>Reels.getSymbol(inActiveReels[i], j);
                            if(symbol !== null) {
                                symbol.changeState({
                                    state : GameConfig.instance.SYMBOL_STATES.normal,
                                    replay : false,
                                    fadeInDuration : 0.2
                                });
                            }
                        }
                    }
                } else {
                    const inActiveReels:number[] = [0, 4];
                    for(let i:number = 0; i < inActiveReels.length; i++) {
                        let symToFade:DirtyWildsStateReelSymbol[] = [];
                        let reelSymbols = <DirtyWildsStateReelSymbol[]>Reels.allSymbols(inActiveReels[i]);
                        if(reelSymbols.length > 0) {
                            let activeSymbols = reelSymbols.filter((a) => {
                                return this._possibleWinSymbols.indexOf(a.symName) > -1
                            });
                            for(let j:number = 0; j < activeSymbols.length; j++) {
                                symToFade.push(activeSymbols[j]);
                                for(let k:number = 0; k < this._betWins.length; k++) {
                                    let betWin = this._betWins[k];
                                    if(activeSymbols[j].symName === betWin.symbol) {
                                        const activeSymIndex = reelSymbols.indexOf(activeSymbols[j]);
                                        if((betWin.betLine[inActiveReels[i]] === (activeSymIndex - 1) && betWin.winPosition[activeSymIndex - 1])) {
                                            if(symToFade.indexOf(activeSymbols[j]) > -1) {
                                                symToFade.splice(symToFade.indexOf(activeSymbols[j]), 1);
                                            }
                                        }
                                    }
                                }
                            }
                            for(let l:number = 0; l < symToFade.length; l++) {
                                symToFade[l].changeState({
                                    state : DirtyWildsGameConfig.instance.SYMBOL_STATES.randomObslete,
                                    replay : false,
                                    fadeInDuration : 0.2
                                });
                            }
                        }
                    }
                }
                // DirtyWildGameModuleConfig.environment.stopSyncTemplePresentation();
            }
        }
    }

    protected parseFeatureTriggered(data:ParsedGameData):boolean {

        this._isRandomSyncFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomSyncFeatureTriggered;
        this._possibleWinSymbols = data.reels[1];
        this._betWins = <IAdjacentBetLineWinData[]>data.betWins;
        return this._isRandomSyncFeatureTriggered;
    }

    protected resetFeature():void {
    }

    //Happens when reels are spinning and data have been received.
    protected startPresentation(timeline:TimelineLite):void {
        this._reelStopped = [];
        this.startRandomPresentation();
    }

    private startRandomPresentation():TimelineLite {
        const tl:TimelineLite = new TimelineLite({
            onComplete : () => {

            }
        });
        const tlSpine:TimelineLite = DirtyWildGameModuleConfig.environment.startMysteryPresentation("TeaseStart", 0, 340, 370)!;
        const logoSpine:TimelineLite = DirtyWildGameModuleConfig.environment.startMysteryPresentation("FlashOnLogo", 0, 340, 370, 0)!;
        const endSpine:TimelineLite = DirtyWildGameModuleConfig.environment.startMysteryPresentation("TeaseToBig", 0, 340, 370)!;
        tl.add([tlSpine,
            () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.RADNOM_TEASE)], 0);
        tl.add([logoSpine,
            () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.RANDOM_FEATURE_TRIGGERED)], tlSpine.totalDuration() - 0.4);
        tl.add([endSpine]);
        tl.add([
            DirtyWildGameModuleConfig.environment.highlightFeature("mysterySync"),
            () => SlotGame.sound.playEffect(DirtyWildsSoundConfig.RANDOM_FEATURE_LOCKED),
        ], tl.totalDuration() - (endSpine.totalDuration() / 1.6));
        tl.add(() => {
            SlotGame.sound.playEffect(DirtyWildsSoundConfig.ANTICIPATION_SYNC);
            EventHandler.dispatchEvent(new GameEvent(DirtyWildsRFSyncEvent.SET_EVENT_VARIABLE, true));
            DirtyWildGameModuleConfig.environment.startMysteryPresentation("BigLoop", -1, 340, 370);
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
        }, tl.totalDuration() - (endSpine.totalDuration() / 1.62));
        tl.add([() => this.initiateRandomBehaviour(),
            () => {
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.STOP));
            }]);
        console.log("timeline Duration:" + tl.totalDuration());
        tl.set({}, {}, (tlSpine.totalDuration() + endSpine.totalDuration()));
        DirtyWildGameModuleConfig.effectManager.getTeaseIntense(3);
        return tl;
    }

    private resetSyncFeature():void {
        if(this._isRandomSyncFeatureTriggered) {
            DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.NORMAL, 2);
        }
    }

    private initiateRandomBehaviour():void {
        let middleReels:number[] = [1, 2, 3];
        let animDelay:number = 0;
        for(let i = 0; i < middleReels.length; i++) {
            const reelController:DirtyWildsReelController = <DirtyWildsReelController>Reels.getReel(middleReels[i])!;
            if(!reelController.isQuickStop()) {
                animDelay = reelController.setDirtyWildRFSyncReelSpeed(middleReels[i], 0.15, 5, true);
            }
        }
    }

    private slowDownReels(reelId:number, endSpeed:number, steps:number, addReelStopDelay:boolean = false, showFrame:boolean = true):void {
        const reelController:DirtyWildsReelController = <DirtyWildsReelController>Reels.getReel(reelId)!;
        if(!reelController.isQuickStop()) {
            let left:number = 620;
            let right:number = 370;
            let animDelay:number = reelController.setDirtyWildRFSyncReelSpeed(reelId, endSpeed, steps, addReelStopDelay);
            switch(reelId) {
                case 0:
                    left = 76;
                    EventHandler.dispatchEvent(new GameEvent(DirtyWildsRFSyncEvent.ADD_DIRTY_SYNC_DELAY, 4, 2 * animDelay));
                    break;
            }

            if(showFrame) {
                DirtyWildGameModuleConfig.environment.startMysteryPresentation("TallFrame", -1, left, right);
                SlotGame.sound.playEffect(DirtyWildsSoundConfig.ANTICIPATION_SYNC);
            }
        }
    }

    private animateSecondReelSet(reelId:number):void {

    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted) {
            // DirtyWildGameModuleConfig.environment.stopSyncTemplePresentation();
        }
    }
}